export default [
  { name: "realtime", features: ["realtime-detail", "realtime-geo"] },
  { name: "alerts", features: ["alerts-detail", "alerts-geo"] },
  { name: "kpi", features: ["kpi-config"] },
  { name: "reports", features: ["reports-detail", "reports-download"] },
  { name: "licences", features: ["licences-config"] },
  {
    name: "users",
    features: [
      "users-watchmen",
      "users-profil",
      "users-device",
      "users-epi",
      "users-remote",
      "users-card",
      "users-planning",
    ],
  },
  { name: "groups", features: ["groups-detail", "groups-config"] },
  { name: "indoor", features: ["indoor-plans", "indoor-ap"] },
  { name: "patrols", features: ["patrols-detail", "patrols-config"] },
  { name: "certificate", features: ["certificate-config"] },
  { name: "phonebook", features: ["phonebook-config"] },
];



// WEBPACK FOOTER //
// ./src/components/roles/beepiz-features.js